import { message, Tooltip } from "antd";
import { FC, PropsWithChildren, useEffect, useState } from "react";
import { notificationError } from "../../../services/notification";
import { IButtonProps } from "./types";

const Button: FC<PropsWithChildren<IButtonProps>> = (props) => {
  const disbledStyle = {
    backgroundColor: "#8d8d8d",
    cursor: "not-allowed",
  };

  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    if (tooltipVisible || !props.disabled)
      setTimeout(() => {
        setTooltipVisible(false);
      }, 2000);
  }, [tooltipVisible, props.disabled]);

  const getStyle = () => {
    if (props.disabled) return { ...props.style, ...disbledStyle };
    if (props.style) return props.style;
    return {};
  };

  return (
    <>
      <Tooltip
        zIndex={1}
        open={tooltipVisible}
        title={"Action not available"}
        color="gray"
        placement="bottomLeft"
        overlayClassName=""
      >
        <button
          id={props.id}
          onClick={
            props.disabled ? () => setTooltipVisible(true) : props.onClick
          }
          className={`button-component 
            ${props.type && "button-component--" + props.type} 
            ${props.customClass}`}
          style={getStyle()}
        >
          {props.children}
        </button>
      </Tooltip>
    </>
  );
};

export default Button;
